import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-autocomplete-singleselect',
  templateUrl: './autocomplete-singleselect.component.html',
  styleUrls: ['./autocomplete-singleselect.component.scss'],
})
export class AutocompleteSingleselectComponent  implements OnInit {
  @Input() items: any[] = [];
  @Input() selected: any = null;
  @Input() displayKey: string = 'name';

  searchTerm = '';
  filteredItems: any[] = [];

  constructor(private popoverCtrl: PopoverController) {}

  ngOnInit() {
    this.filteredItems = [...this.items]; // default list
  }

  filterItems(event: any) {
    const query = event.target.value.toLowerCase();
    this.filteredItems = this.items.filter(i =>
      i[this.displayKey].toLowerCase().includes(query)
    );
  }

  selectItem(item: any) {
    this.popoverCtrl.dismiss(item);
  }

  close() {
    this.popoverCtrl.dismiss(null);
  }

}
